import advantage from "../../Assets/homev2/advantage.png";
import ai from "../../Assets/homev2/ai.png";
import branding from "../../Assets/homev2/branding.png";
import bundles from "../../Assets/homev2/bundles.png";
import campaign from "../../Assets/homev2/campaigns.png";
import content from "../../Assets/homev2/content.png";
import sales from "../../Assets/homev2/sales.png";
import talent from "../../Assets/homev2/talent.png";
import video from "../../Assets/homev2/video.png";

const productsData = [
	{
		title: "Sales",
		image: {
			src: sales,
			alt: "Sales",
		},
		link: "/reach-out?services=sales-strategy",
	},
	{
		title: "Campaigns",
		image: {
			src: campaign,
			alt: "Campaigns",
		},
		link: "/reach-out?services=digital-marketing",
	},
	{
		title: "Video",
		image: {
			src: video,
			alt: "Video",
		},
		link: "/reach-out?services=video-production",
	},
	{
		title: "Branding",
		image: {
			src: branding,
			alt: "Branding",
		},
		link: "/reach-out?services=brand-creative",
	},
	{
		title: "Content",
		image: {
			src: content,
			alt: "Content",
		},
		link: "/reach-out?services=copy-content",
	},
	{
		title: "Talent",
		image: {
			src: talent,
			alt: "Talent",
		},
		link: "/reach-out?services=build-my-team",
	},
	{
		title: "AI",
		image: {
			src: ai,
			alt: "AI",
		},
		link: "/reach-out?services=ai-tech",
	},
	{
		title: "Bundles",
		image: {
			src: bundles,
			alt: "Bundles",
		},
		link: "/reach-out",
	},
	{
		title: "Advantage",
		image: {
			src: advantage,
			alt: "Advantage",
		},
		link: "/reach-out",
	},
];

const ProductList = () => {
    return (
        <section className="w-full max-w-[1500px] mx-auto py-16 px-4">
            <div className="flex items-start md:items-center flex-col md:flex-row md:justify-between gap-4">
                <div className="text-black flex flex-col text-xl text-center lg:text-3xl  font-semibold mx-auto">
                    <p className="md:hidden items-start">Salesmrkt.</p>
                    <p>
                        <span className="hidden md:inline"> Salesmrkt.</span> Your
                        One-Stop-Shop
                        <br />
                        for OnDemand B2B Solutions To Grow Your Business.
                    </p>
                </div>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-6 xl:gap-10 mt-10">
                {productsData.map((data, index) => (
                    <a
                        key={index}
                        href={data.link}
                        className="w-full h-full flex flex-col items-center justify-between gap-2   sm:last:col-span-1"
                    >
                        <div className="h-full flex items-center justify-center">
                            <img
                                src={data.image.src}
                                alt={data.image.alt}
                                width="100%"
                                height="100%"
                                loading="lazy"
                            />
                        </div>
                        <h4 className="text-center text-black font-medium">{data.title}</h4>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default ProductList;
